// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lapras_gmax: PokeData = {
  "id": 10204,
  "name": "lapras-gmax",
  "height": 240,
  "weight": 10000,
  "base_experience": 187,
  "types": [
    PokeType.WATER,
    PokeType.ICE
  ],
  "api_moves": [],
  "moves": [
    "aqua-cutter",
    "hydro-pump",
    "ice-fang",
    "ice-punch",
    "aqua-tail",
    "vacuum-wave",
    "blizzard",
    "water-spout",
    "aqua-jet",
    "ice-shard",
    "icicle-dagger",
    "brine",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 65,
    "item": null,
    "species": [
      {
        "name": "lapras",
        "order": 155,
        "types": [
          PokeType.WATER,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 171,
    "speed": 95,
    "ability_power": 134
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
